/**
 * Where a program meets, as a small pill with a map-pin — "Annex Room 2".
 *
 * Renders nothing when there is no location, so callers can drop it into a pill row
 * unconditionally.
 */

import { MapPin } from 'lucide-react';

interface LocationPillProps {
  /** Display name, usually from `programLocationName(program)`. */
  name: string | null | undefined;
  /** `xs` for dense rows and cards, `sm` for headers. */
  size?: 'xs' | 'sm';
  className?: string;
}

export function LocationPill({ name, size = 'xs', className = '' }: LocationPillProps) {
  if (!name) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-sky-50 text-sky-800 border border-sky-200 font-medium leading-tight min-w-0 ${
        size === 'xs' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-0.5 text-xs'
      } ${className}`.trim()}
      title={name}
    >
      <MapPin className={size === 'xs' ? 'h-3 w-3 flex-shrink-0' : 'h-3.5 w-3.5 flex-shrink-0'} aria-hidden="true" />
      <span className="sr-only">Location: </span>
      <span className="truncate">{name}</span>
    </span>
  );
}

